(function (angular) {
	'use strict';

	angular.module('changeBankAccountModalModule', [
		'coreModule',
		'formValidationModule',
		'plaidModule'
	]);
})(window.angular);